import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PresentationEditorPage } from '../features/presentations/presentation-authoring-pages';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/slides/$slideId',
)({ component: RouteComponent, validateSearch: z.object({ comment: z.uuid().optional() }) });
function RouteComponent() {
  const params = Route.useParams();
  const search = Route.useSearch();
  return <PresentationEditorPage {...params} commentId={search.comment} />;
}
